<template>
  <div>
    <v-dialog v-model="ebayDetailsModal" persistent>
      <v-toolbar class="redColor text-white">
        <v-toolbar-title>{{
          $t("institutions.table.ebay_details")
        }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          variant="outlined"
          icon
          color="white"
          @click="closeEbayDetailsModal"
        >
          <v-icon small> mdi-close </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card class="pa-3">
        <v-progress-linear
          v-if="loading"
          color="#D32F2F"
          indeterminate
          rounded
          height="6"
        />
        <div />
        <v-row class="d-flex flex-nowrap">
          <v-col cols="6" class="pa-3">
            <div>
              <v-text-field
                v-model="item.token"
                :label="$t('institutions.form.token')"
                color="red-darken-1"
                prepend-icon="mdi-security"
              />
            </div>
            <div>
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                min-width="290px"
              >
                <template #activator="{ props }">
                  <v-text-field
                    v-model="formattedTokenExpirationDate"
                    v-bind="props"
                    :label="$t('institutions.form.tokenExpirationDate')"
                    color="black"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                  />
                </template>

                <v-card class="d-md-flex">
                  <!-- Date Picker -->
                  <v-date-picker
                    v-model="date"
                    color="red-darken-3"
                    @update:model-value="updateTokenExpirationDate"
                  />

                  <!-- Time Picker -->
                  <v-time-picker
                    v-model="time"
                    color="red-darken-3"
                    full-width
                    format="24hr"
                    @update:model-value="updateTokenExpirationDate"
                  />
                  <!-- <v-card-actions>
                    <v-btn text @click="saveDateTime">{{ $t('institutions.form.save') }}</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-menu>
            </div>
            <!-- <div>
          <v-text-field
            v-model="item.shippingId"
            :label="$t('institutions.form.shippingId')"
            color="red-darken-1"
            prepend-icon="shop"
          />
        </div>
        <div>
          <v-text-field
            v-model="item.paymentId"
            :label="$t('institutions.form.paymentId')"
            color="red-darken-1"
            prepend-icon="payment"
          />
        </div>
        <div>
          <v-text-field
            v-model="item.returnId"
            :label="$t('institutions.form.returnId')"
            color="red-darken-1"
            prepend-icon="refresh"
          />
        </div> -->
            <div>
              <v-text-field
                v-model="item.userId"
                disabled
                :label="$t('institutions.form.userId')"
                color="red-darken-1"
                prepend-icon="mdi-account"
              />
            </div>
            <div>
              <v-text-field
                v-model="item.storeUrl"
                disabled
                :label="$t('institutions.form.storeUrl')"
                color="red-darken-1"
                prepend-icon="mdi-link-variant"
              />
            </div>
            <div>
              <v-text-field
                v-model="item.eBayLocation"
                :label="$t('institutions.form.location')"
                color="red-darken-1"
                prepend-icon="mdi-city"
              />
            </div>
            <v-alert
              :model-value="true"
              type="error"
              border="bottom"
              variant="outlined"
              text
            >
              {{ $t("institutions.form.ebay_condition") }}
            </v-alert>
          </v-col>
          <v-col cols="6">
            <v-tabs v-model="selectedCountry" align-tabs="center">
              <v-tab
                v-for="country in countries"
                :key="country"
                :value="country"
              >
                {{ country.toUpperCase() }}
              </v-tab>
            </v-tabs>

            <v-window v-model="selectedCountry" class="mt-4">
              <v-window-item
                v-for="country in countries"
                :key="country"
                :value="country"
              >
                <v-container>
                  <!-- Scrollable section for shipping IDs -->
                  <div
                    style="
                      max-height: 300px;
                      overflow-y: auto;
                      overflow-x: hidden;
                    "
                  >
                    <v-row
                      v-for="(value, range) in item.shippingId[country]"
                      :key="'shipping-' + range"
                      class="d-flex flex-nowrap pa-4"
                    >
                      <v-text-field
                        v-model="item.shippingId[country][range]"
                        :label="
                          range === 'default'
                            ? 'Default Shipping ID'
                            : `Shipping ID (${range} kg)`
                        "
                        color="red-darken-1"
                        prepend-inner-icon="mdi-store"
                      />

                      <v-btn
                        class="mt-2"
                        :color="
                          item.shippingId[country][range] ? 'success' : ''
                        "
                        @click="
                          verifyShippingId(
                            item.token,
                            item.shippingId[country][range],
                            item.paymentId[country],
                            item.returnId[country],
                            country,
                          )
                        "
                      >
                        Verify
                      </v-btn>
                    </v-row>
                  </div>

                  <!-- Payment ID -->
                  <v-text-field
                    v-model="item.paymentId[country]"
                    label="Payment ID"
                    color="red-darken-1"
                    prepend-inner-icon="mdi-credit-card-outline"
                  />

                  <!-- Return ID -->
                  <v-text-field
                    v-model="item.returnId[country]"
                    label="Return ID"
                    color="red-darken-1"
                    prepend-inner-icon="mdi-refresh"
                  />

                  <!-- Best Offer -->
                  <div class="mt-4">
                    {{ $t("institutions.form.minBestOffer") }}
                    <div class="col-12 d-flex align-center">
                      <v-text-field
                        v-model="item.minimumBestOfferPercentage[country]"
                        label="%"
                        hint="max. 45%"
                        type="number"
                        :min="0"
                        :max="45"
                        color="red-darken-1"
                        prepend-inner-icon="mdi-poll"
                        @input="
                          item.minimumBestOfferPercentage[country] > 45
                            ? (item.minimumBestOfferPercentage[country] = 0)
                            : ''
                        "
                      />
                      <v-switch
                        v-model="item.bestOffer[country]"
                        :label="$t('institutions.form.enableBestOffer')"
                        class="mb-2 ml-2"
                        color="red-darken-1"
                        hide-details
                        :disabled="!item.minimumBestOfferPercentage[country]"
                      />
                    </div>
                  </div>
                </v-container>
              </v-window-item>
            </v-window>
            <!-- <v-tabs-items v-model="selectedCountry">
              <v-tab-item
                v-for="country in ['it', 'de']"
                :key="country"
              >
                <v-container>
                  <v-text-field
                    v-model="item.shippingId[country]"
                    :label="$t('institutions.form.shippingId')"
                    color="red-darken-1"
                    prepend-icon="shop"
                  />
                  <v-text-field
                    v-model="item.paymentId[country]"
                    :label="$t('institutions.form.paymentId')"
                    color="red-darken-1"
                    prepend-icon="payment"
                  />
                  <v-text-field
                    v-model="item.returnId[country]"
                    :label="$t('institutions.form.returnId')"
                    color="red-darken-1"
                    prepend-icon="refresh"
                  />
                </v-container>
              </v-tab-item>
            </v-tabs-items> -->
          </v-col>
        </v-row>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red-darken-1"
            variant="outlined"
            @click="closeEbayDetailsModal"
          >
            {{ $t("institutions.form.close") }}
          </v-btn>
          <v-btn
            color="green"
            class="white--text"
            variant="outlined"
            :disabled="checkEbayDetails"
            @click="saveEbayDetails"
          >
            {{ $t("institutions.form.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ebayStoreCategoriesModal" persistent width="650">
      <v-toolbar class="redColor text-white">
        <v-toolbar-title>{{
          $t("institutions.table.ebay_store_categories_title")
        }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          variant="outlined"
          icon
          small
          color="white"
          @click="closeEbayCategoriesModal"
        >
          <v-icon small> mdi-close </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card class="pa-3">
        <v-progress-linear
          v-if="loadingSave"
          color="#D32F2F"
          indeterminate
          rounded
          height="6"
        />
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- Language Tabs -->
          <v-tabs v-model="selectedLanguage" align-tabs="center">
            <v-tab
              v-for="lang in languages"
              :key="lang.code"
              :value="lang.code"
            >
              {{ lang.label }}
            </v-tab>
          </v-tabs>

          <!-- Language Content -->
          <v-window v-model="selectedLanguage" class="mt-4">
            <v-window-item
              v-for="lang in languages"
              :key="lang.code"
              :value="lang.code"
            >
              <v-container>
                <!-- Get Categories Button -->
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn
                    color="red"
                    class="text-white"
                    density="comfortable"
                    @click="getCategories(lang.code)"
                  >
                    {{ $t("institutions.form.get_categories") }}
                  </v-btn>
                </v-col>

                <!-- Category Inputs -->
                <v-card class="pa-4 pb-5">
                  <v-row class="d-flex flex-nowrap">
                    <v-text-field
                      v-model="categoryNames[lang.code]"
                      :label="$t('institutions.form.ebay_category_name')"
                      color="red-darken-1"
                      class="mr-4"
                    />
                    <v-text-field
                      v-model="categoryNumbers[lang.code]"
                      :label="$t('institutions.form.ebay_category_number')"
                      color="red-darken-1"
                      type="number"
                      @keypress="isNumber($event)"
                    />
                    <v-btn
                      color="red"
                      class="text-white mt-3 ml-3"
                      density="comfortable"
                      @click="addCategory(lang.code)"
                    >
                      {{ $t("institutions.form.add") }}
                      <v-icon class="ml-1">mdi-plus</v-icon>
                    </v-btn>
                  </v-row>

                  <v-divider class="my-4" />

                  <!-- Category List -->
                  <template
                    v-if="
                      categories.find((c) => c.language === lang.code)
                        ?.categoryList?.length
                    "
                  >
                    <div
                      class="d-flex justify-space-between font-weight-bold mb-2"
                    >
                      <span>{{
                        $t("institutions.form.ebay_category_name")
                      }}</span>
                      <span>{{
                        $t("institutions.form.ebay_category_number")
                      }}</span>
                    </div>

                    <v-row
                      v-for="(category, index) in categories.find(
                        (c) => c.language === lang.code,
                      ).categoryList"
                      :key="index"
                      class="mt-2 d-flex flex-nowrap"
                    >
                      <v-text-field
                        v-model="category.title"
                        :label="$t('institutions.form.ebay_category_name')"
                        color="red-darken-1"
                        class="mr-2"
                        variant="solo"
                        :rules="rules.required"
                      />
                      <v-text-field
                        v-model="category.ebayCode"
                        :label="$t('institutions.form.ebay_category_number')"
                        color="red-darken-1"
                        variant="solo"
                        :rules="rules.required"
                        type="number"
                        @keypress="isNumber($event)"
                      />
                      <v-btn
                        color="red"
                        class="text-white mt-3 ml-3"
                        density="comfortable"
                        @click="deleteCategory(lang.code, index)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-row>
                  </template>
                </v-card>
              </v-container>
            </v-window-item>
          </v-window>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red-darken-1"
            variant="outlined"
            @click="closeEbayCategoriesModal"
          >
            {{ $t("institutions.form.close") }}
          </v-btn>
          <v-btn color="green" variant="outlined" @click="saveCategories()">
            {{ $t("institutions.form.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="ebayErrorDialog" persistent width="500">
      <v-card class="pa-3">
        <v-alert
          v-for="(item, index) in normalizedEbayResponse"
          :key="index"
          :value="true"
          type="error"
        >
          {{ item.ShortMessage }}
        </v-alert>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn small @click="ebayErrorDialog = false"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="ebayErrorDetailsDialog" persistent width="500">
      <v-card class="pa-3">
        <v-alert
          v-if="ebayResponse && ebayResponse.it"
          :value="true"
          type="error"
        >
          <strong>IT: </strong> {{ ebayResponse.it }}
        </v-alert>
        <v-alert
          v-if="ebayResponse && ebayResponse.de"
          :value="true"
          type="error"
        >
          <strong>DE: </strong> {{ ebayResponse.de }}
        </v-alert>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn small @click="closeEbayDetailsErrprModal()"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="alert" max-width="500">
      <v-alert v-model="alert" type="success" dismissible :value="true">
        {{ $t("institutions.form.verification_success") }}
      </v-alert>
    </v-dialog>
    <v-dialog v-model="success" max-width="300">
      <v-alert v-model="success" type="success" dismissible :value="true">
        {{ $t("institutions.form.success") }}
      </v-alert>
    </v-dialog>
    <v-dialog v-model="ebayPreferencesModal" persistent width="500">
      <v-toolbar class="redColor text-white">
        <v-toolbar-title
          >Ebay {{ $t("institutions.table.preferences") }}</v-toolbar-title
        >
        <v-spacer />
        <v-btn
          variant="outlined"
          icon
          small
          color="white"
          @click="closeEbayPreferences"
        >
          <v-icon small> mdi-close </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card class="pa-3">
        <v-row class="d-flex flex-nowrap align-center mb-2 font-weight-bold">
          <v-col cols="4"></v-col>
          <v-col cols="4" class="text-center">
            {{ $t("institutions.form.export") }}
          </v-col>
          <v-col cols="4" class="text-center">
            {{ $t("institutions.form.duplicate") }}
          </v-col>
        </v-row>
        <v-divider />
        <v-row
          v-for="(exportValue, locale) in exportEbayLekoInternational"
          :key="locale"
          class="d-flex flex-nowrap justify-space-around mb-2"
        >
          <div class="col-2 pt-4">
            <img :src="getImg(locale)" />
          </div>

          <!-- Export Switch -->
          <div class="col-5">
            <v-switch
              v-model="exportEbayLekoInternational[locale]"
              :disabled="locale == 'it'"
              color="red-darken-1"
            />
          </div>

          <!-- Duplicate Switch -->
          <div class="col-5">
            <v-switch
              v-model="duplicateEbayListings[locale]"
              color="red-darken-1"
            />
          </div>
        </v-row>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn
            variant="outlined"
            color="green darken-2"
            @click="saveEbayPreferences()"
          >
            {{ $t("institutions.form.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="warning" max-width="500">
      <v-alert v-model="warning" type="warning" dismissible :value="true">
        {{ requiredFields }} are required
      </v-alert>
    </v-dialog>
    <v-dialog v-model="verifyShippingErrorModal" max-width="500">
      <v-card class="pa-3">
        <v-alert
          v-model="verifyShippingErrorModal"
          type="error"
          dismissible
          :value="true"
        >
          {{ verificationError }}
        </v-alert>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  data: () => ({
    institution_id: null,
    ebayDetailsModal: false,
    item: {
      token: "",
      tokenExpirationDate: "",
      shippingId: {
        it: {
          default: "",
          "0-2": "",
          "2,1-5": "",
          "5,1-10": "",
          "10,1-15": "",
          "15,1-25": "",
          "25,1-50": "",
          "50,1-75": "",
          "75,1-100": "",
          "100,1": "",
          "101,1-150": "",
          "150,1-200": "",
          "201,1-250": "",
          "250,1-300": "",
        },
        de: {
          default: "",
          "0-2": "",
          "2,1-5": "",
          "5,1-10": "",
          "10,1-15": "",
          "15,1-25": "",
          "25,1-50": "",
          "50,1-75": "",
          "75,1-100": "",
          "100,1": "",
          "101,1-150": "",
          "150,1-200": "",
          "201,1-250": "",
          "250,1-300": "",
        },
        fr: {
          default: "",
          "0-2": "",
          "2,1-5": "",
          "5,1-10": "",
          "10,1-15": "",
          "15,1-25": "",
          "25,1-50": "",
          "50,1-75": "",
          "75,1-100": "",
          "100,1": "",
          "101,1-150": "",
          "150,1-200": "",
          "201,1-250": "",
          "250,1-300": "",
        },
        es: {
          default: "",
          "0-2": "",
          "2,1-5": "",
          "5,1-10": "",
          "10,1-15": "",
          "15,1-25": "",
          "25,1-50": "",
          "50,1-75": "",
          "75,1-100": "",
          "100,1": "",
          "101,1-150": "",
          "150,1-200": "",
          "201,1-250": "",
          "250,1-300": "",
        },
        nl: {
          default: "",
          "0-2": "",
          "2,1-5": "",
          "5,1-10": "",
          "10,1-15": "",
          "15,1-25": "",
          "25,1-50": "",
          "50,1-75": "",
          "75,1-100": "",
          "100,1": "",
          "101,1-150": "",
          "150,1-200": "",
          "201,1-250": "",
          "250,1-300": "",
        },
        pl: {
          default: "",
          "0-2": "",
          "2,1-5": "",
          "5,1-10": "",
          "10,1-15": "",
          "15,1-25": "",
          "25,1-50": "",
          "50,1-75": "",
          "75,1-100": "",
          "100,1": "",
          "101,1-150": "",
          "150,1-200": "",
          "201,1-250": "",
          "250,1-300": "",
        },
      },
      paymentId: {
        it: "",
        de: "",
        fr: "",
        es: "",
        nl: "",
        pl: "",
      },
      returnId: {
        it: "",
        de: "",
        fr: "",
        es: "",
        nl: "",
        pl: "",
      },
      bestOffer: {
        it: false,
        de: false,
        fr: false,
        es: false,
        nl: false,
        pl: false,
      },
      minimumBestOfferPercentage: {
        it: null,
        de: null,
        fr: null,
        es: null,
        nl: null,
        pl: null,
      },
      userId: "",
      storeUrl: "",
      eBayLocation: "",
    },
    selectedCountry: "it",
    countries: ["it", "de", "fr", "es", "nl", "pl"],
    dateMenu: false,
    date: null,
    time: null,
    ebayResponse: null,
    ebayErrorDialog: false,
    loading: false,
    alert: false,
    inst: null,
    ebayStoreCategoriesModal: false,
    loadingSave: false,
    institutionDetails: null,
    selectedLanguage: "it",
    languages: [
      { code: "it", label: "IT" },
      { code: "en", label: "EN" },
      { code: "de", label: "DE" },
      { code: "fr", label: "FR" },
      { code: "es", label: "ES" },
      { code: "nl", label: "NL" },
      { code: "pl", label: "PL" },
    ],
    categoryNames: {
      it: "",
      en: "",
      de: "",
      fr: "",
      es: "",
      nl: "",
      pl: "",
    },
    categoryNumbers: {
      it: "",
      en: "",
      de: "",
      fr: "",
      es: "",
      nl: "",
      pl: "",
    },
    // categories: {
    //   it: [],
    //   en: [],
    //   de: [],
    //   fr: [],
    // },
    categoryInputs: {
      it: { title: "", ebayCode: "" },
      en: { title: "", ebayCode: "" },
      de: { title: "", ebayCode: "" },
      fr: { title: "", ebayCode: "" },
      es: { title: "", ebayCode: "" },
      nl: { title: "", ebayCode: "" },
      pl: { title: "", ebayCode: "" },
    },
    defaultCategories: [
      {
        language: "it",
        categoryList: [
          { title: "Lamierati esterni", ebayCode: "" },
          { title: "Lamierati interni", ebayCode: "" },
          { title: "Fanaleria", ebayCode: "" },
          { title: "Selleria", ebayCode: "" },
          { title: "Motore e cambio con supporti", ebayCode: "" },
          { title: "Paraurti anteriore", ebayCode: "" },
          { title: "Paraurti posteriore", ebayCode: "" },
          { title: "Sterzo", ebayCode: "" },
          { title: "Sospensioni", ebayCode: "" },
          { title: "Cristalli", ebayCode: "" },
          { title: "Alimentazione e scarico", ebayCode: "" },
          { title: "Cambio e trasmissioni", ebayCode: "" },
          { title: "Impianto frenante", ebayCode: "" },
          { title: "Rivestimenti interni e parti interne", ebayCode: "" },
          { title: "Dispositivi di sicurezza", ebayCode: "" },
          { title: "Climatizzazione", ebayCode: "" },
          // { title: 'Altro', ebayCode: '' },
        ],
      },
      {
        language: "en",
        categoryList: [
          // { title: 'Other', ebayCode: '' },
        ],
      },
      {
        language: "de",
        categoryList: [
          // { title: 'Andere', ebayCode: '' },
        ],
      },
      {
        language: "fr",
        categoryList: [
          // { title: 'Autre', ebayCode: '' },
        ],
      },
      {
        language: "es",
        categoryList: [
          // { title: 'Autre', ebayCode: '' },
        ],
      },
      {
        language: "nl",
        categoryList: [
          // { title: 'Autre', ebayCode: '' },
        ],
      },
      {
        language: "pl",
        categoryList: [
          // { title: 'Autre', ebayCode: '' },
        ],
      },
    ],
    categories: [
      {
        language: "it",
        categoryList: [],
      },
      { language: "en", categoryList: [] },
      { language: "de", categoryList: [] },
      { language: "fr", categoryList: [] },
      { language: "es", categoryList: [] },
      { language: "nl", categoryList: [] },
      { language: "pl", categoryList: [] },
    ],
    // baseUrl: 'http://localhost:3000',
    baseUrl: "https://api.lekotech.com",
    rules: {
      required: [(v) => !!v || "Please fill this field"],
    },
    valid: false,
    success: false,
    ebayPreferencesModal: false,
    tab: "export",
    preferences: [{ title: "export" }, { title: "duplicates" }],
    exportEbayLekoInternational: {
      it: true,
      de: false,
      fr: false,
      es: false,
      nl: false,
      pl: false,
    },
    duplicateEbayListings: {
      it: false,
      de: false,
      fr: false,
      es: false,
      nl: false,
      pl: false,
    },
    ebayErrorDetailsDialog: false,
    requiredFields: "",
    warning: false,
    verifyShippingErrorModal: false,
    verificationError: "",
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
    checkEbayDetails() {
      const { token, tokenExpirationDate, paymentId, returnId } = this.item;

      return !token || !tokenExpirationDate || !paymentId.it || !returnId.it;
    },
    formattedTokenExpirationDate() {
      if (!this.item.tokenExpirationDate) return "";
      const date = new Date(this.item.tokenExpirationDate);
      return date.toString().slice(0, 28);
    },
    normalizedEbayResponse() {
      if (
        this.ebayResponse &&
        typeof this.ebayResponse === "object" &&
        !Array.isArray(this.ebayResponse)
      ) {
        return [this.ebayResponse];
      }
      return this.ebayResponse || [];
    },
  },
  watch: {
    valid(value) {
      this.$emit("valid", value);
    },
  },

  methods: {
    openEbayDetailsModal(institution) {
      this.institution_id = institution._id;
      this.inst = institution;
      const shippingIt =
        institution.eBayDetails &&
        institution.eBayDetails.shippingId &&
        institution.eBayDetails.shippingId.it
          ? institution.eBayDetails.shippingId.it
          : {
              default: "",
              "0-2": "",
              "2,1-5": "",
              "5,1-10": "",
              "10,1-15": "",
              "15,1-25": "",
              "25,1-50": "",
              "50,1-75": "",
              "75,1-100": "",
              "100,1": "",
              "101,1-150": "",
              "150,1-200": "",
              "201,1-250": "",
              "250,1-300": "",
            };
      const shippingDe =
        institution.eBayDetails &&
        institution.eBayDetails.shippingId &&
        institution.eBayDetails.shippingId.de
          ? institution.eBayDetails.shippingId.de
          : {
              default: "",
              "0-2": "",
              "2,1-5": "",
              "5,1-10": "",
              "10,1-15": "",
              "15,1-25": "",
              "25,1-50": "",
              "50,1-75": "",
              "75,1-100": "",
              "100,1": "",
              "101,1-150": "",
              "150,1-200": "",
              "201,1-250": "",
              "250,1-300": "",
            };
      const shippingFR =
        institution.eBayDetails &&
        institution.eBayDetails.shippingId &&
        institution.eBayDetails.shippingId.fr
          ? institution.eBayDetails.shippingId.fr
          : {
              default: "",
              "0-2": "",
              "2,1-5": "",
              "5,1-10": "",
              "10,1-15": "",
              "15,1-25": "",
              "25,1-50": "",
              "50,1-75": "",
              "75,1-100": "",
              "100,1": "",
              "101,1-150": "",
              "150,1-200": "",
              "201,1-250": "",
              "250,1-300": "",
            };
      const shippingES =
        institution.eBayDetails &&
        institution.eBayDetails.shippingId &&
        institution.eBayDetails.shippingId.es
          ? institution.eBayDetails.shippingId.es
          : {
              default: "",
              "0-2": "",
              "2,1-5": "",
              "5,1-10": "",
              "10,1-15": "",
              "15,1-25": "",
              "25,1-50": "",
              "50,1-75": "",
              "75,1-100": "",
              "100,1": "",
              "101,1-150": "",
              "150,1-200": "",
              "201,1-250": "",
              "250,1-300": "",
            };
      const shippingNL =
        institution.eBayDetails &&
        institution.eBayDetails.shippingId &&
        institution.eBayDetails.shippingId.nl
          ? institution.eBayDetails.shippingId.nl
          : {
              default: "",
              "0-2": "",
              "2,1-5": "",
              "5,1-10": "",
              "10,1-15": "",
              "15,1-25": "",
              "25,1-50": "",
              "50,1-75": "",
              "75,1-100": "",
              "100,1": "",
              "101,1-150": "",
              "150,1-200": "",
              "201,1-250": "",
              "250,1-300": "",
            };
      const shippingPL =
        institution.eBayDetails &&
        institution.eBayDetails.shippingId &&
        institution.eBayDetails.shippingId.pl
          ? institution.eBayDetails.shippingId.pl
          : {
              default: "",
              "0-2": "",
              "2,1-5": "",
              "5,1-10": "",
              "10,1-15": "",
              "15,1-25": "",
              "25,1-50": "",
              "50,1-75": "",
              "75,1-100": "",
              "100,1": "",
              "101,1-150": "",
              "150,1-200": "",
              "201,1-250": "",
              "250,1-300": "",
            };
      this.item = {
        token:
          institution.eBayDetails && institution.eBayDetails.token
            ? institution.eBayDetails.token
            : "",
        tokenExpirationDate:
          institution.eBayDetails && institution.eBayDetails.tokenExpirationDate
            ? institution.eBayDetails.tokenExpirationDate
            : "",
        // shippingId: {
        //   it: institution.eBayDetails && institution.eBayDetails.shippingId && institution.eBayDetails.shippingId.it || '',
        //   de: institution.eBayDetails && institution.eBayDetails.shippingId && institution.eBayDetails.shippingId.de || '',
        // },
        shippingId: {
          it: {
            default: shippingIt ? shippingIt.default : null,
            "0-2": shippingIt ? shippingIt[2] : null,
            "2,1-5": shippingIt ? shippingIt[5] : null,
            "5,1-10": shippingIt ? shippingIt[10] : null,
            "10,1-15": shippingIt ? shippingIt[15] : null,
            "15,1-25": shippingIt ? shippingIt[25] : null,
            "25,1-50": shippingIt ? shippingIt[50] : null,
            "50,1-75": shippingIt ? shippingIt[75] : null,
            "75,1-100": shippingIt ? shippingIt[100] : null,
            "100,1": shippingIt ? shippingIt[101] : null,
            "101,1-150": shippingIt ? shippingIt[150] : null,
            "150,1-200": shippingIt ? shippingIt[200] : null,
            "201,1-250": shippingIt ? shippingIt[250] : null,
            "250,1-300": shippingIt ? shippingIt[300] : null,
          },
          de: {
            default: shippingDe ? shippingDe.default : null,
            "0-2": shippingDe ? shippingDe[2] : null,
            "2,1-5": shippingDe ? shippingDe[5] : null,
            "5,1-10": shippingDe ? shippingDe[10] : null,
            "10,1-15": shippingDe ? shippingDe[15] : null,
            "15,1-25": shippingDe ? shippingDe[25] : null,
            "25,1-50": shippingDe ? shippingDe[50] : null,
            "50,1-75": shippingDe ? shippingDe[75] : null,
            "75,1-100": shippingDe ? shippingDe[100] : null,
            "100,1": shippingDe ? shippingDe[101] : null,
            "101,1-150": shippingDe ? shippingDe[150] : null,
            "150,1-200": shippingDe ? shippingDe[200] : null,
            "201,1-250": shippingDe ? shippingDe[250] : null,
            "250,1-300": shippingDe ? shippingDe[300] : null,
          },
          fr: {
            default: shippingFR ? shippingFR.default : null,
            "0-2": shippingFR ? shippingFR[2] : null,
            "2,1-5": shippingFR ? shippingFR[5] : null,
            "5,1-10": shippingFR ? shippingFR[10] : null,
            "10,1-15": shippingFR ? shippingFR[15] : null,
            "15,1-25": shippingFR ? shippingFR[25] : null,
            "25,1-50": shippingFR ? shippingFR[50] : null,
            "50,1-75": shippingFR ? shippingFR[75] : null,
            "75,1-100": shippingFR ? shippingFR[100] : null,
            "100,1": shippingFR ? shippingFR[101] : null,
            "101,1-150": shippingFR ? shippingFR[150] : null,
            "150,1-200": shippingFR ? shippingFR[200] : null,
            "201,1-250": shippingFR ? shippingFR[250] : null,
            "250,1-300": shippingFR ? shippingFR[300] : null,
          },
          es: {
            default: shippingES ? shippingES.default : null,
            "0-2": shippingES ? shippingES[2] : null,
            "2,1-5": shippingES ? shippingES[5] : null,
            "5,1-10": shippingES ? shippingES[10] : null,
            "10,1-15": shippingES ? shippingES[15] : null,
            "15,1-25": shippingES ? shippingES[25] : null,
            "25,1-50": shippingES ? shippingES[50] : null,
            "50,1-75": shippingES ? shippingES[75] : null,
            "75,1-100": shippingES ? shippingES[100] : null,
            "100,1": shippingES ? shippingES[101] : null,
            "101,1-150": shippingES ? shippingES[150] : null,
            "150,1-200": shippingES ? shippingES[200] : null,
            "201,1-250": shippingES ? shippingES[250] : null,
            "250,1-300": shippingES ? shippingES[300] : null,
          },
          nl: {
            default: shippingNL ? shippingNL.default : null,
            "0-2": shippingNL ? shippingNL[2] : null,
            "2,1-5": shippingNL ? shippingNL[5] : null,
            "5,1-10": shippingNL ? shippingNL[10] : null,
            "10,1-15": shippingNL ? shippingNL[15] : null,
            "15,1-25": shippingNL ? shippingNL[25] : null,
            "25,1-50": shippingNL ? shippingNL[50] : null,
            "50,1-75": shippingNL ? shippingNL[75] : null,
            "75,1-100": shippingNL ? shippingNL[100] : null,
            "100,1": shippingNL ? shippingNL[101] : null,
            "101,1-150": shippingNL ? shippingNL[150] : null,
            "150,1-200": shippingNL ? shippingNL[200] : null,
            "201,1-250": shippingNL ? shippingNL[250] : null,
            "250,1-300": shippingNL ? shippingNL[300] : null,
          },
          pl: {
            default: shippingPL ? shippingPL.default : null,
            "0-2": shippingPL ? shippingPL[2] : null,
            "2,1-5": shippingPL ? shippingPL[5] : null,
            "5,1-10": shippingPL ? shippingPL[10] : null,
            "10,1-15": shippingPL ? shippingPL[15] : null,
            "15,1-25": shippingPL ? shippingPL[25] : null,
            "25,1-50": shippingPL ? shippingPL[50] : null,
            "50,1-75": shippingPL ? shippingPL[75] : null,
            "75,1-100": shippingPL ? shippingPL[100] : null,
            "100,1": shippingPL ? shippingPL[101] : null,
            "101,1-150": shippingPL ? shippingPL[150] : null,
            "150,1-200": shippingPL ? shippingPL[200] : null,
            "201,1-250": shippingPL ? shippingPL[250] : null,
            "250,1-300": shippingPL ? shippingPL[300] : null,
          },
        },
        paymentId: {
          it:
            (institution.eBayDetails &&
              institution.eBayDetails.paymentId &&
              institution.eBayDetails.paymentId.it) ||
            "",
          de:
            (institution.eBayDetails &&
              institution.eBayDetails.paymentId &&
              institution.eBayDetails.paymentId.de) ||
            "",
          fr:
            (institution.eBayDetails &&
              institution.eBayDetails.paymentId &&
              institution.eBayDetails.paymentId.fr) ||
            "",
          es:
            (institution.eBayDetails &&
              institution.eBayDetails.paymentId &&
              institution.eBayDetails.paymentId.es) ||
            "",
          nl:
            (institution.eBayDetails &&
              institution.eBayDetails.paymentId &&
              institution.eBayDetails.paymentId.nl) ||
            "",
          pl:
            (institution.eBayDetails &&
              institution.eBayDetails.paymentId &&
              institution.eBayDetails.paymentId.pl) ||
            "",
        },
        returnId: {
          it:
            (institution.eBayDetails &&
              institution.eBayDetails.returnId &&
              institution.eBayDetails.returnId.it) ||
            "",
          de:
            (institution.eBayDetails &&
              institution.eBayDetails.returnId &&
              institution.eBayDetails.returnId.de) ||
            "",
          fr:
            (institution.eBayDetails &&
              institution.eBayDetails.returnId &&
              institution.eBayDetails.returnId.fr) ||
            "",
          es:
            (institution.eBayDetails &&
              institution.eBayDetails.returnId &&
              institution.eBayDetails.returnId.es) ||
            "",
          nl:
            (institution.eBayDetails &&
              institution.eBayDetails.returnId &&
              institution.eBayDetails.returnId.nl) ||
            "",
          pl:
            (institution.eBayDetails &&
              institution.eBayDetails.returnId &&
              institution.eBayDetails.returnId.pl) ||
            "",
        },
        bestOffer: {
          it:
            (institution.eBayDetails &&
              institution.eBayDetails.bestOffer &&
              institution.eBayDetails.bestOffer.it) ||
            false,
          de:
            (institution.eBayDetails &&
              institution.eBayDetails.bestOffer &&
              institution.eBayDetails.bestOffer.de) ||
            false,
          fr:
            (institution.eBayDetails &&
              institution.eBayDetails.bestOffer &&
              institution.eBayDetails.bestOffer.fr) ||
            false,
          es:
            (institution.eBayDetails &&
              institution.eBayDetails.bestOffer &&
              institution.eBayDetails.bestOffer.es) ||
            false,
          nl:
            (institution.eBayDetails &&
              institution.eBayDetails.bestOffer &&
              institution.eBayDetails.bestOffer.nl) ||
            false,
          pl:
            (institution.eBayDetails &&
              institution.eBayDetails.bestOffer &&
              institution.eBayDetails.bestOffer.pl) ||
            false,
        },
        minimumBestOfferPercentage: {
          it:
            (institution.eBayDetails &&
              institution.eBayDetails.minimumBestOfferPercentage &&
              institution.eBayDetails.minimumBestOfferPercentage.it) ||
            null,
          de:
            (institution.eBayDetails &&
              institution.eBayDetails.minimumBestOfferPercentage &&
              institution.eBayDetails.minimumBestOfferPercentage.de) ||
            null,
          fr:
            (institution.eBayDetails &&
              institution.eBayDetails.minimumBestOfferPercentage &&
              institution.eBayDetails.minimumBestOfferPercentage.fr) ||
            null,
          es:
            (institution.eBayDetails &&
              institution.eBayDetails.minimumBestOfferPercentage &&
              institution.eBayDetails.minimumBestOfferPercentage.es) ||
            null,
          nl:
            (institution.eBayDetails &&
              institution.eBayDetails.minimumBestOfferPercentage &&
              institution.eBayDetails.minimumBestOfferPercentage.nl) ||
            null,
          pl:
            (institution.eBayDetails &&
              institution.eBayDetails.minimumBestOfferPercentage &&
              institution.eBayDetails.minimumBestOfferPercentage.pl) ||
            null,
        },
        userId: institution.eBayDetails.userId || null,
        storeUrl: institution.eBayDetails.storeUrl || null,
        eBayLocation: institution.eBayDetails.eBayLocation || null,
      };

      if (this.item.tokenExpirationDate) {
        const d = new Date(this.item.tokenExpirationDate);
        this.date = d;
        this.time = `${String(d.getHours()).padStart(2, "0")}:${String(
          d.getMinutes(),
        ).padStart(2, "0")}`;
      } else {
        this.date = null;
        this.time = null;
      }
      this.ebayDetailsModal = true;
    },
    verifyShippingId(accessToken, shippingId, paymentId, returnId, site) {
      const missingFields = [];
      if (!accessToken) missingFields.push("Token");
      if (!shippingId) missingFields.push("Shipping ID");
      if (!paymentId) missingFields.push("Payment ID");
      if (!returnId) missingFields.push("Return ID");

      if (missingFields.length > 0) {
        this.requiredFields = missingFields.join(", ");
        this.warning = true;
        return;
      }
      this.loading = true;

      axios
        .post(
          `${this.baseUrl}/ebay/verify-add-item`,
          {
            accessToken,
            shippingId,
            paymentId,
            returnId,
            site,
          },
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((response) => {
          if (response && response.data && response.data.errorMsg) {
            this.verificationError = response.data.errorMsg;
            this.verifyShippingErrorModal = true;
          } else {
            this.alert = true;
            setTimeout(() => {
              this.alert = false;
            }, 3000);
            this.$emit("fetchInstitutionDetails");
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveEbayDetails() {
      const {
        shippingId,
        paymentId,
        returnId,
        minimumBestOfferPercentage,
        ...rest
      } = this.item;
      const transformedShippingIdIt = {};
      const transformedShippingIdDE = {};
      const transformedShippingIdFR = {};
      const transformedShippingIdES = {};
      const transformedShippingIdNL = {};
      const transformedShippingIdPL = {};
      // Map current shippingId labels to the new format
      const weightMapping = {
        "0-2": "2",
        "2,1-5": "5",
        "5,1-10": "10",
        "10,1-15": "15",
        "15,1-25": "25",
        "25,1-50": "50",
        "50,1-75": "75",
        "75,1-100": "100",
        "100,1": "101",
        "101,1-150": "150",
        "150,1-200": "200",
        "201,1-250": "250",
        "250,1-300": "300",
      };
      Object.keys(shippingId.it).forEach((label) => {
        if (shippingId.it[label]) {
          const newKey = weightMapping[label] || label;
          transformedShippingIdIt[newKey] = shippingId.it[label];
        }
      });
      const filteredData = {
        ...rest,
        shippingId: { it: transformedShippingIdIt },
        paymentId: { it: paymentId.it },
        returnId: { it: returnId.it },
      };
      // DE
      const isGermanyFilled =
        Object.values(shippingId.de).some((value) => value) ||
        !!paymentId.de ||
        !!returnId.de;
      if (isGermanyFilled) {
        Object.keys(shippingId.de).forEach((label) => {
          if (shippingId.de[label]) {
            const newKey = weightMapping[label] || label;
            transformedShippingIdDE[newKey] = shippingId.de[label];
          }
        });
        // Add 'de' fields if fully filled
        filteredData.shippingId.de = transformedShippingIdDE;
        filteredData.paymentId.de = paymentId.de;
        filteredData.returnId.de = returnId.de;
      }
      // FR
      const isFranceFilled =
        Object.values(shippingId.fr).some((value) => value) ||
        !!paymentId.fr ||
        !!returnId.fr;
      if (isFranceFilled) {
        Object.keys(shippingId.fr).forEach((label) => {
          if (shippingId.fr[label]) {
            const newKey = weightMapping[label] || label;
            transformedShippingIdFR[newKey] = shippingId.fr[label];
          }
        });
        // Add 'fr' fields if fully filled
        filteredData.shippingId.fr = transformedShippingIdFR;
        filteredData.paymentId.fr = paymentId.fr;
        filteredData.returnId.fr = returnId.fr;
      }
      // ES
      const isSpainFilled =
        Object.values(shippingId.es).some((value) => value) ||
        !!paymentId.es ||
        !!returnId.es;
      if (isSpainFilled) {
        Object.keys(shippingId.es).forEach((label) => {
          if (shippingId.es[label]) {
            const newKey = weightMapping[label] || label;
            transformedShippingIdES[newKey] = shippingId.es[label];
          }
        });
        // Add 'es' fields if fully filled
        filteredData.shippingId.es = transformedShippingIdES;
        filteredData.paymentId.es = paymentId.es;
        filteredData.returnId.es = returnId.es;
      }
      // NL
      const isNetherlandsFilled =
        Object.values(shippingId.nl).some((value) => value) ||
        !!paymentId.nl ||
        !!returnId.nl;
      if (isNetherlandsFilled) {
        Object.keys(shippingId.nl).forEach((label) => {
          if (shippingId.nl[label]) {
            const newKey = weightMapping[label] || label;
            transformedShippingIdNL[newKey] = shippingId.nl[label];
          }
        });
        // Add 'nl' fields if fully filled
        filteredData.shippingId.nl = transformedShippingIdNL;
        filteredData.paymentId.nl = paymentId.nl;
        filteredData.returnId.nl = returnId.nl;
      }
      // PL
      const isPolandFilled =
        Object.values(shippingId.pl).some((value) => value) ||
        !!paymentId.pl ||
        !!returnId.pl;
      if (isPolandFilled) {
        Object.keys(shippingId.pl).forEach((label) => {
          if (shippingId.pl[label]) {
            const newKey = weightMapping[label] || label;
            transformedShippingIdPL[newKey] = shippingId.pl[label];
          }
        });
        // Add 'pl' fields if fully filled
        filteredData.shippingId.pl = transformedShippingIdPL;
        filteredData.paymentId.pl = paymentId.pl;
        filteredData.returnId.pl = returnId.pl;
      }
      this.loading = true;
      filteredData.minimumBestOfferPercentage = {
        it: minimumBestOfferPercentage.it
          ? parseInt(minimumBestOfferPercentage.it, 10)
          : null,
        de: minimumBestOfferPercentage.de
          ? parseInt(minimumBestOfferPercentage.de, 10)
          : null,
        es: minimumBestOfferPercentage.es
          ? parseInt(minimumBestOfferPercentage.es, 10)
          : null,
        fr: minimumBestOfferPercentage.fr
          ? parseInt(minimumBestOfferPercentage.fr, 10)
          : null,
        nl: minimumBestOfferPercentage.nl
          ? parseInt(minimumBestOfferPercentage.nl, 10)
          : null,
        pl: minimumBestOfferPercentage.pl
          ? parseInt(minimumBestOfferPercentage.pl, 10)
          : null,
      };

      axios
        .put(
          `${this.baseUrl}/institution/edit-ebay-details/${this.institution_id}`,
          { eBayDetails: filteredData },
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((response) => {
          if (response && response.data && response.data.errorMsg) {
            this.ebayResponse = response.data;
            this.ebayErrorDetailsDialog = true;
          } else {
            this.alert = true;
            this.ebayDetailsModal = false;
            // this.item = response.data && response.data.eBayDetails ? response.data.eBayDetails : {
            //   token: '',
            //   tokenExpirationDate: '',
            //   shippingId: { it: '', de: '' },
            //   paymentId: { it: '', de: '' },
            //   returnId: { it: '', de: '' },
            //   userId: '',
            //   storeUrl: '',
            // };
            setTimeout(() => {
              this.alert = false;
            }, 3000);
            this.$emit("fetchInstitutionDetails");
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeEbayDetailsErrprModal() {
      this.ebayErrorDetailsDialog = false;
      this.ebayResponse = null;
    },
    closeEbayDetailsModal() {
      this.ebayDetailsModal = false;
      this.selectedCountry = "it";
      this.$emit("fetchInstitutionDetails");
    },
    updateTokenExpirationDate() {
      if (this.date && this.time) {
        const [hours, minutes] = this.time.split(":");
        const fullDate = new Date(this.date);
        fullDate.setHours(hours, minutes, 0, 0);
        this.item.tokenExpirationDate = fullDate.toISOString();
      }
    },
    saveDateTime() {
      this.dateMenu = false;
    },
    closeDateTimeMenu() {
      this.dateMenu = false;
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {})
        .catch(() => {});
    },
    openEbayStoreCategoriesModal(institution) {
      this.ebayStoreCategoriesModal = true;
      this.institutionDetails = institution;
      this.institution_id = institution._id;

      axios
        .get(
          `${this.baseUrl}/ebay-local-categories/?institution_id=${institution._id}`,
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((res) => {
          const defaultCategories = [
            { language: "it", categoryList: [] },
            { language: "en", categoryList: [] },
            { language: "de", categoryList: [] },
            { language: "fr", categoryList: [] },
            { language: "es", categoryList: [] },
            { language: "nl", categoryList: [] },
            { language: "pl", categoryList: [] },
          ];

          const dbCategories = res.data.ebayCategories.categories || null;

          if (!dbCategories) {
            this.categories = defaultCategories;
          } else {
            // Create a Map from dbCategories for quick lookup
            const dbMap = new Map(
              dbCategories.map((cat) => [cat.language, cat]),
            );

            // Merge with default categories to ensure all languages are present
            this.categories = defaultCategories.map(
              (def) => dbMap.get(def.language) || def,
            );
          }
        })
        .catch(() => {})
        .finally(() => {
          // nth
        });
    },
    closeEbayCategoriesModal() {
      this.ebayStoreCategoriesModal = false;
    },
    saveCategories() {
      if (this.$refs.form.validate()) {
        this.loadingSave = true;
        axios
          .put(
            `${this.baseUrl}/ebay-local-categories/?institution_id=${this.institution_id}`,
            { categories: this.categories },
            {
              headers: { authorization: localStorage.token },
            },
          )
          .then(() => {
            this.loadingSave = false;
            this.success = true;
            this.$emit("fetchInstitutionDetails");
            setTimeout(() => {
              this.success = false;
            }, 3000);
          })
          .catch(() => {
            this.loadingSave = false;
          })
          .finally(() => {
            this.loadingSave = false;
            this.ebayStoreCategoriesModal = false;
          });
      } else {
        //
      }
    },
    addCategory(lang) {
      if (this.categoryNames[lang]) {
        const categoryForLang = this.categories.find(
          (cat) => cat.language === lang,
        );
        if (categoryForLang) {
          categoryForLang.categoryList.push({
            title: this.categoryNames[lang],
            ebayCode: this.categoryNumbers[lang],
          });
        }
        this.categoryNames[lang] = "";
        this.categoryNumbers[lang] = "";
      } else {
        //
      }
    },
    deleteCategory(langCode, index) {
      const langCategory = this.categories.find((c) => c.language === langCode);
      if (langCategory) {
        langCategory.categoryList.splice(index, 1);
      }
    },
    openEbayPreferencesModal(institution) {
      this.institution_id = institution._id;
      if (
        institution &&
        institution.exportEbayLekoInternational &&
        Object.keys(institution.exportEbayLekoInternational).length > 0
      ) {
        this.exportEbayLekoInternational = {
          it: institution.export_ebay_leko,
          de:
            institution.exportEbayLekoInternational &&
            institution.exportEbayLekoInternational.de
              ? institution.exportEbayLekoInternational.de
              : false,
          fr:
            institution.exportEbayLekoInternational &&
            institution.exportEbayLekoInternational.fr
              ? institution.exportEbayLekoInternational.fr
              : false,
          es:
            institution.exportEbayLekoInternational &&
            institution.exportEbayLekoInternational.es
              ? institution.exportEbayLekoInternational.es
              : false,
          nl:
            institution.exportEbayLekoInternational &&
            institution.exportEbayLekoInternational.nl
              ? institution.exportEbayLekoInternational.nl
              : false,
          pl:
            institution.exportEbayLekoInternational &&
            institution.exportEbayLekoInternational.pl
              ? institution.exportEbayLekoInternational.pl
              : false,
        };
      } else {
        this.exportEbayLekoInternational = {
          it: institution.export_ebay_leko,
          de: false,
          fr: false,
          nl: false,
          pl: false,
        };
      }
      if (
        institution &&
        institution.duplicateEbayListings &&
        Object.keys(institution.duplicateEbayListings).length > 0
      ) {
        this.duplicateEbayListings = {
          it:
            institution.duplicateEbayListings &&
            institution.duplicateEbayListings.it
              ? institution.duplicateEbayListings.it
              : false,
          de:
            institution.duplicateEbayListings &&
            institution.duplicateEbayListings.de
              ? institution.duplicateEbayListings.de
              : false,
          fr:
            institution.duplicateEbayListings &&
            institution.duplicateEbayListings.fr
              ? institution.duplicateEbayListings.fr
              : false,
          es:
            institution.duplicateEbayListings &&
            institution.duplicateEbayListings.es
              ? institution.duplicateEbayListings.es
              : false,
          nl:
            institution.duplicateEbayListings &&
            institution.duplicateEbayListings.nl
              ? institution.duplicateEbayListings.nl
              : false,
          pl:
            institution.duplicateEbayListings &&
            institution.duplicateEbayListings.pl
              ? institution.duplicateEbayListings.pl
              : false,
        };
      } else {
        this.duplicateEbayListings = {
          it: false,
          de: false,
          fr: false,
          es: false,
          nl: false,
          pl: false,
        };
      }

      this.ebayPreferencesModal = true;
    },
    saveEbayPreferences() {
      this.loading = true;
      axios
        .put(
          `${this.baseUrl}/institution/edit-ebay-leko-preferences/${this.institution_id}`,
          {
            exportEbayLekoInternational: this.exportEbayLekoInternational,
            duplicateEbayListings: this.duplicateEbayListings,
          },
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((response) => {
          if (response && response.data && response.data.errorMsg) {
            this.ebayResponse = response.data.errorMsg;
            this.ebayErrorDialog = true;
          } else {
            this.alert = true;
            this.ebayPreferencesModal = false;
            setTimeout(() => {
              this.alert = false;
            }, 3000);
            this.$emit("fetchInstitutionDetails");
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeEbayPreferences() {
      this.ebayPreferencesModal = false;
    },
    getCategories(site) {
      axios
        .get(`${this.baseUrl}/ebay-local-categories/categories?site=${site}`, {
          headers: { authorization: localStorage.token },
        })
        .then((res) => {
          const categoryList = (res.data.categories || []).map((item) => ({
            title: item[site],
            ebayCode: "",
          }));
          const langIndex = this.categories.findIndex(
            (c) => c.language === site,
          );
          if (langIndex !== -1) {
            this.categories[langIndex].categoryList = categoryList;
          } else {
            this.categories.push({ language: site, categoryList });
          }
        })
        .catch(() => {});
    },
    getImg(item) {
      switch (item) {
        case "it":
          return "https://portal.lekotech.com/img/icons/ebayIcons/italy.svg";
        case "de":
          return "https://portal.lekotech.com/img/icons/ebayIcons/germany.svg";
        case "es":
          return "https://portal.lekotech.com/img/icons/ebayIcons/spain.svg";
        case "fr":
          return "https://portal.lekotech.com/img/icons/ebayIcons/france.svg";
        case "uk":
          return "https://portal.lekotech.com/img/icons/ebayIcons/united-kingdom.svg";
        case "nl":
          return "https://portal.lekotech.com/img/icons/ebayIcons/netherlands.png";
        case "pl":
          return "https://portal.lekotech.com/img/icons/ebayIcons/poland.png";
        default:
          return "/";
      }
    },
    isNumber(evt) {
      // Only allow numeric values (digits 0-9)
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      }
    },
  },
};
</script>
